export default ({ request }) => ({
  userReimbursementListApi(data = {}) {
    return request({
      url: '/financial/user/reimbursement/list',
      method: 'POST',
      data,
    })
  },
})
